import { copy } from "shared/assets";
import { IFieldType, IFormFields, IFormOption } from "shared/types";

type PaperSizes = keyof typeof copy.event.pdf.fields.paperSizes;

const errors = copy.errors;

interface Props {
  eventBlockOptions: IFormOption[];
  setEventBlockOptions: (options: IFormOption[]) => void;
}

export const getFields = ({
  eventBlockOptions,
  setEventBlockOptions,
}: Props): IFormFields => [
  {
    name: "title",
    label: copy.event.pdf.fields.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
      validate: (value: string) =>
        !!value.replaceAll(" ", "") || errors.required,
    },
  },
  {
    name: "paperSize",
    type: IFieldType.radioGroup,
    label: copy.event.pdf.fields.paperSize,
    options: Object.keys(copy.event.pdf.fields.paperSizes).map((size) => ({
      value: size,
      label: copy.event.pdf.fields.paperSizes[size as PaperSizes],
    })),
    validation: {
      required: errors.required,
    },
  },
  {
    name: "intro",
    label: copy.event.pdf.fields.intro,
    type: IFieldType.rte,
  },
  {
    name: "eventBlocks",
    label: copy.event.pdf.fields.showInfo,
    type: IFieldType.draggableCheckboxGroup,
    note: copy.event.pdf.messages.drag,
    options: eventBlockOptions,
    setOptions: setEventBlockOptions,
    validation: {
      required: copy.event.pdf.errors.eventBlocks,
    },
  },
  {
    name: "showMyPersonalInfo",
    label: copy.event.pdf.fields.showPersonalInfo,
    type: IFieldType.checkbox,
    superLabel: copy.event.pdf.fields.other,
  },
];
